module.exports = __webpack_public_path__ + "img/errorIcon.c19c2156.svg";